// Series that carry no displayable image: reports, presentation states, key
// objects, encapsulated PDFs, waveforms, segmentations, RT objects,
// registrations, … The series panel must never pick one of these as the
// "first" series (thumbnail index 0 is what the viewport auto-loads), and
// preloading them is pointless.
export const NON_IMAGE_SERIES_MODALITIES = new Set([
  "SR",       // structured report
  "PR",       // presentation state
  "KO",       // key object selection
  "DOC",      // encapsulated PDF / document
  "ECG",      // waveform
  "HD",       // hemodynamic waveform
  "AU",       // audio
  "SEG",      // segmentation
  "RTSTRUCT", // RT structure set
  "RTPLAN",
  "RTRECORD",
  "REG",      // registration
  "FID",      // fiducials
  "PLAN",
]);

/**
 * True when a stack shows no image. Checks the series' own DICOM modality as
 * well as the stack's: buildSeriesStack replaces an unknown series modality
 * (e.g. ECG in a CT study) with the study's, so stack.modality alone can say
 * "CT" for a waveform series.
 */
export const isNonImageSeries = (stack) =>
  !!stack &&
  (NON_IMAGE_SERIES_MODALITIES.has(stack.modality) ||
    NON_IMAGE_SERIES_MODALITIES.has(stack.seriesModality));

/** Index of the first stack that shows an image, or -1. */
export const firstImageSeriesIndex = (stacks) =>
  (stacks ?? []).findIndex((s) => !isNonImageSeries(s));
